import PartnersTable from './PartnersTable';

export default PartnersTable;
